import {VelaScene, type VelaRule} from '../engine/types';

export const taxesRules: VelaRule[] = [
  {
    id: 'taxes/ask-exemption-declared',
    section: 'askVela',
    scenes: [VelaScene.Taxes],
    priority: 100,
    evaluate: (ctx, t) =>
      ctx.taxes.exemptCount > 0
        ? {
            id: 'ask-exemption-declared',
            title: t('chat.taxes.exemption_declared.q'),
            description: t('chat.taxes.exemption_declared.a'),
          }
        : null,
  },
  {
    id: 'taxes/ask-why',
    section: 'askVela',
    scenes: [VelaScene.Taxes],
    priority: 90,
    evaluate: ({taxes}, t) => ({
      id: 'ask-why',
      title: t('chat.taxes.why.q'),
      description: !taxes.rate
        ? t('chat.taxes.why.a_no_rate')
        : t(
            taxes.isPerDay ? 'chat.taxes.why.a_rate_day' : 'chat.taxes.why.a_rate_night',
            {
              rate: taxes.rate,
              perGuest: taxes.perGuest,
            },
          ),
    }),
  },
  {
    id: 'taxes/ask-who-exempt',
    section: 'askVela',
    scenes: [VelaScene.Taxes],
    priority: 80,
    evaluate: (ctx, t) =>
      ctx.taxes.canDeclareExemptions
        ? {
            id: 'ask-who-exempt',
            title: t('chat.taxes.who_exempt.q'),
            description: t('chat.taxes.who_exempt.a'),
          }
        : null,
  },
  {
    id: 'taxes/ask-unregistered',
    section: 'askVela',
    scenes: [VelaScene.Taxes],
    priority: 70,
    evaluate: (ctx, t) =>
      ctx.taxes.unregisteredCount > 0
        ? {
            id: 'ask-unregistered',
            title: t('chat.taxes.unregistered.q'),
            description: t('chat.taxes.unregistered.a'),
          }
        : null,
  },
  {
    id: 'taxes/ask-charged-now',
    section: 'askVela',
    scenes: [VelaScene.Taxes],
    priority: 60,
    evaluate: (_, t) => ({
      id: 'ask-charged-now',
      title: t('chat.taxes.charged_now.q'),
      description: t('chat.taxes.charged_now.a'),
    }),
  },
];
